import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromTopPrismaActions from '../actions/top-prisma.actions';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';
import {WebshopRestService} from '../../services/api/webshop-rest.service';
import {ProductsResponse} from '../../models/shop/products-response.model';
import {ProductType} from '../../models/shop/product-type.model';

@Injectable()
export class TopPrismaEffects {
    private actions$ = inject(Actions);
    private productRestService = inject(WebshopRestService);
    /**
     * In case of SearchInvoicesAction we're going to call the InvoicesService and then
     * we'll post a LoadInvoicesCompleteAction to the reducer or in case of failure
     * LoadInvoicesFailAction
     *
     * @type {Observable<any>}
     */
    loadTopPrisma$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromTopPrismaActions.LoadTopPrismaAction>(
                fromTopPrismaActions.TopPrismaActionTypes.LOAD_TOPPRISMA
            ),
            map(action => action.payload),
            switchMap(productRequest =>
                this.productRestService.loadTopPrisma(productRequest).pipe(
                    switchMap(data => {
                        const prodResp = new ProductsResponse({
                            ...data.returnObject,
                            ...{ type: ProductType.TopPrisma }
                        });
                        if (productRequest.page === 1) {
                            return [
                                new fromTopPrismaActions.LoadTopPrismaCompleteAction(prodResp),
                                new fromTopPrismaActions.GetBatchFromCacheAction()
                            ];
                        } else {
                            return [new fromTopPrismaActions.LoadTopPrismaCompleteAction(prodResp)];
                        }
                    }),
                    catchError(error => of(new fromTopPrismaActions.LoadTopPrismaFailAction(error)))
                )
            )
        )
    );

    searchTopPrisma$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromTopPrismaActions.SearchShopAction>(
                fromTopPrismaActions.TopPrismaActionTypes.SEARCH_TOPPRISMA
            ),
            map(action => action.payload),
            switchMap(productRequest => [
                new fromTopPrismaActions.LoadTopPrismaAction(productRequest)
            ])
        )
    );

}
